// extracted by css-extract-rspack-plugin
export default {"profile":"VFRWm","with_no_ad_badge":"YjUHy","withNoAdBadge":"YjUHy","avatar_override":"jRIeu","avatarOverride":"jRIeu","#":"nuAJS"};